import Skeleton from "react-loading-skeleton";

import "./styles.sass";

const SkeletonFooterMobile = () => {
  return (
    <div className="SkeletonFooterMobile">
      <div className="SkeletonFooterMobile__logo">
        <Skeleton width={117} height={28} />
      </div>

      <div className="SkeletonFooterMobile__header">
        <Skeleton
          width={148}
          height={28}
          className="SkeletonFooterMobile__header_title"
        />
        <Skeleton width="90%" height={14} />
      </div>

      <div className="SkeletonFooterMobile__blocks">
        <div className="SkeletonFooterMobile__block">
          <div className="SkeletonFooterMobile__title">
            <Skeleton width={52} height={19} />
          </div>
          <div className="SkeletonFooterMobile__item">
            <Skeleton width={58} height={14} />
          </div>
          <div className="SkeletonFooterMobile__item">
            <Skeleton width={58} height={14} />
          </div>
          <div className="SkeletonFooterMobile__item">
            <Skeleton width={58} height={14} />
          </div>
          <div className="SkeletonFooterMobile__item">
            <Skeleton width={58} height={14} />
          </div>
        </div>
        <div className="SkeletonFooterMobile__block">
          <div className="SkeletonFooterMobile__title">
            <Skeleton width={94} height={19} />
          </div>
          <div className="SkeletonFooterMobile__item">
            <Skeleton width={28} height={14} />
          </div>
          <div className="SkeletonFooterMobile__item">
            <Skeleton width={93} height={14} />
          </div>
          <div className="SkeletonFooterMobile__item">
            <Skeleton width={101} height={14} />
          </div>
          <div className="SkeletonFooterMobile__item">
            <Skeleton width={156} height={14} />
          </div>
          <div className="SkeletonFooterMobile__item">
            <Skeleton width={101} height={14} />
          </div>
          <div className="SkeletonFooterMobile__item">
            <Skeleton width={120} height={14} />
          </div>
        </div>
      </div>

      <div className="SkeletonFooterMobile__payments">
        <Skeleton width={40} height={30} />
        <Skeleton width={40} height={30} />
      </div>

      <div className="SkeletonFooterMobile__partners">
        <div className="SkeletonFooterMobile__partner">
          <Skeleton width={54} height={40} />
          <Skeleton width={64} height={24} />
        </div>
        <div className="SkeletonFooterMobile__partner">
          <Skeleton width={37} height={24} />
        </div>
        <div className="SkeletonFooterMobile__partner">
          <Skeleton width={100} height={13} />
        </div>
        <div className="SkeletonFooterMobile__partner">
          <Skeleton width={24} height={24} />
        </div>
      </div>

      <div className="SkeletonFooterMobile__text">
        <Skeleton width="91%" height={6} />
        <Skeleton width="92%" height={6} />
        <Skeleton width="89%" height={6} />
        <Skeleton width="93%" height={6} />
        <Skeleton width="90%" height={6} />
        <Skeleton width="88%" height={6} />
        <Skeleton width="87%" height={6} />
        <Skeleton width="91%" height={6} />
        <Skeleton width="93%" height={6} />
      </div>
    </div>
  );
};

export default SkeletonFooterMobile;
